<app-language-switcher></app-language-switcher>

<div class="grid">
  <div class="grid-cols-12">
      <b>Titolo </b>{{'Sitetitle' | translate}}

      <b>Errore su nome </b>{{'NameError' | translate}}
  </div>
  <div class="grid-cols-12 bg-sky-300 rounded-lg mt-2 flex-col flex">
    <span class="text-white text-2xl p-2">Test traduzioni con pipe da componente .ts</span>

    <button (click)="GenerateToast()" class=" p-2 rounded-lg bg-rose-500 text-white font-bold m-4 hover:bg-red-500 ">Crea toast</button>
  </div>
</div>
